import { useEffect, useState } from "react";
import { MessageSquare } from "lucide-react";
import { api, formatErr, cx } from "../lib/api";
import ChatDrawer from "./ChatDrawer";

export default function AdminMessagesPanel() {
  const [threads, setThreads] = useState([]);
  const [error, setError] = useState(null);
  const [openId, setOpenId] = useState(null);

  const reload = async () => {
    try {
      const { data } = await api.get("/messages/threads");
      setThreads(data.items || []);
    } catch (e) { setError(formatErr(e)); }
  };

  useEffect(() => { reload(); const id = setInterval(reload, 15000); return () => clearInterval(id); }, []);

  return (
    <div>
      <div className="mb-5">
        <div className="eyebrow">Concierge desk</div>
        <h2 className="font-serif-display text-3xl mt-1">All conversations</h2>
        <p className="text-sm text-muted mt-1">Booking threads + concierge channels across the platform.</p>
      </div>

      {error && <div className="text-rose-300 text-sm mb-4">{error}</div>}

      {threads.length === 0 ? (
        <div className="luxe-card p-10 text-center text-muted text-sm">No conversations yet.</div>
      ) : (
        <div className="space-y-2" data-testid="admin-thread-list">
          {threads.map((th) => (
            <button key={th.id} onClick={() => setOpenId(th.id)}
                    className="w-full luxe-card p-4 flex items-start gap-4 text-left hover:border-teal/40 transition"
                    data-testid={`thread-row-${th.id}`}>
              <div className={cx("h-10 w-10 rounded-full grid place-items-center shrink-0",
                                th.kind === "concierge" ? "bg-teal text-ink" : "bg-white/5 border hairline")}>
                <MessageSquare size={14}/>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5 flex-wrap">
                  <span className="chip">{th.kind}</span>
                  <span className="font-medium truncate">{th.title || "Conversation"}</span>
                  {th.unread_count > 0 && (
                    <span className="chip danger !py-0.5 !text-[10px]" data-testid={`thread-unread-${th.id}`}>{th.unread_count}</span>
                  )}
                </div>
                {th.last_message_preview ? (
                  <div className="text-xs text-muted truncate">{th.last_message_preview}</div>
                ) : (
                  <div className="text-xs text-muted/60 italic">No messages yet</div>
                )}
              </div>
              {th.last_message_at && (
                <div className="text-[10px] text-muted/60 font-mono shrink-0">
                  {new Date(th.last_message_at).toLocaleDateString()}
                </div>
              )}
            </button>
          ))}
        </div>
      )}

      {openId && (
        <ChatDrawer threadId={openId} onClose={() => { setOpenId(null); reload(); }} />
      )}
    </div>
  );
}
